import React from 'react';
import { useState } from "react";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import Card from 'react-bootstrap/Card';
import { SignIn, UserCircle } from 'phosphor-react';
import JasonFile from "./formLangfields.json";
import { Dropdown } from 'react-bootstrap';
import "../../src/helper/Header.css";
import mlj from "../helper/images/mlj.png";
import moe_logo from "../helper/images/moe_logo.png";
import anu_logo from "../helper/images/anuvadini_logo.png"

function RegisterValidatorPage() {
    const navigate = useNavigate();
    const [language, setLanguage] = useState();
    const [rePassword, setRepassword] = useState();
    const [inputList, setinputList] = useState({
        name: "",
        mobile: "",
        password: "",
        email: "",
        defaultLanguage: "",
    });

    const HandleChange = (data) => {
        let variable = data.target.name;
        let value = data.target.value;
        if (variable == "name") {
            if (/^[a-zA-Z ]*$/.test(value) === false) {
                return '';
            }
        }
        if (variable == "mobile") {
            if (value > 9999999999) {
                return '';
            }
        }
        let items = { ...inputList };
        items[variable] = value;
        setinputList(items);
    };

    const registerHandler = (e) => {
        e.preventDefault();
        let items = { ...inputList };
        items['defaultLanguage'] = language;
        items['role'] = 'validator';
        setinputList(items);
        axios
            .post(process.env.REACT_APP_BASE_URL + "user-registration-validator", items, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('legaltoken')}`
                },
            })
            .then(function (response) {
                if (response.data.status === "success") {
                    alert('Validator created !!')
                    navigate("/lawdictionary/list");
                }
            })
            .catch(function (response) {
                alert("Something went wrong!");
            });
    }


    return (
        <>
            <div className="topDivLogin searchList">
                <header className="headerLst">
                    <div className="container mainSrchDiv">
                        <div className="mainSrchDivIn">
                            <div className="row align-items-center">
                                <div className="logoarea col-12 col-sm-12 col-md-9 col-lg-9">
                                    <div className="d-flex justify-content-start flex-wrap align-items-center">
                                        <div className="listLogo">
                                            <a href="https://anuvadini.aicte-india.org/">
                                                <img src={anu_logo} width="210px" />
                                            </a>
                                            <a>
                                                <img src={mlj} alt="" width="200px" style={{ marginLeft: 10 }} />
                                            </a>
                                            <a href="">
                                                <img src={moe_logo} alt="" style={{ marginLeft: 10, }} width="120px"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </div>

            <div className='container loginFooter mb-5'>
                <Card className='loginCard'>
                    <Card.Body>
                        <form onSubmit={registerHandler}>
                            <div className='text-center'>
                                <UserCircle size={80} color="#7167e4" />
                                <h3>Register Validator</h3>
                            </div>
                            <div className="mb-3">
                                <label>Name</label>
                                <input type="text" className="form-control" name="name" value={inputList?.name} onChange={e => HandleChange(e)} />
                            </div>

                            <div className="mb-3">
                                <label>Email</label>
                                <input type="email" className="form-control" name="email" value={inputList?.email} onChange={e => HandleChange(e)} />
                            </div>

                            <div className="mb-3">
                                <label>Mobile Number</label>
                                <input type="number" className="form-control" name="mobile" value={inputList?.mobile} onChange={e => HandleChange(e)} />
                            </div>

                            <div className="mb-3 d-flex justify-content-between">
                                <div className='w-100'>
                                    <label>Select Language</label>
                                    <Dropdown className='text-start w-100'>
                                        <Dropdown.Toggle className='selectmenu text-start p-relative w-100' variant="default">Select Language </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {Object.entries(JasonFile[0]).map((res, i) => {
                                                return (
                                                    <Dropdown.Item value={res[0]} onClick={(e) => setLanguage(res[0])} key={i}>{res[1]}</Dropdown.Item> // onClick={(e) => setLang(res[0])}
                                                )
                                            }
                                            )}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>

                            <div className="mb-3">
                                <label>Password</label>
                                <input type="password" className="form-control" name="password" value={inputList?.password} onChange={e => HandleChange(e)} />
                            </div>

                            <div className="mb-3">
                                <label>Confirm Password</label>
                                <input type="password" className="form-control" name="rePassword" value={rePassword} onChange={e => setRepassword(e.target.value)} />
                            </div>

                            <div className="d-grid">
                                <button type="submit" className="btnsuccess w-auto"><SignIn size={20} />Submit</button>
                            </div>
                        </form>
                    </Card.Body>
                </Card>
            </div>
        </>
    )
}

export default RegisterValidatorPage;

